import {CApi as adminGwApi} from '@services/api';

export const loginAsClientFunc = async (
    clientLogin: string | undefined,
    host?: 'prod' | 'test'
): Promise<string | null> => {
    try {
        if (!clientLogin) return null;

        const response = await adminGwApi().impersonate.impersonateCreate({
            client: clientLogin,
            host
        });

        const {url} = response.data;

        if (url) {
            window.open(url, '_blank');
        }

        return null;
    } catch (error: any) {
        console.error('Ошибка при имперсонации клиента:', error);

        const errorMessage =
            error?.response?.data?.violations?.[0]?.message ||
            error?.response?.data?.message ||
            'Произошла ошибка при входе под клиентом';

        return errorMessage;
    }
};
